import ContactPage from "../components/ContactPage";

function Contact() {
    return (
        <ContactPage />
    );
}

export default Contact;